module.exports = __webpack_public_path__ + "da0318ff47115bf85e8673ef7d580c3f.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/svg/header/wizard.svg
// module id = RrDT
// module chunks = 11